const CAP = {
  "title": "Capítulo 16 — ¡Cuidado al firmar!",
  "sections": [
    {
      heading: "Seguridad de firma: ¡CUIDADO al firmar!",
      text: [
        "Si hay un tema crítico en seguridad de NFT, es el de las firmas. Muchas de las grandes estafas en marketplaces de NFT (OpenSea y otros) han ocurrido porque los usuarios firmaron mensajes que NO entendían.",
        "La regla de oro es simple pero poderosa:",
        "“What you see is what you sign” — Lo que ves debe ser exactamente lo que estás firmando.",
        "Es decir, el mensaje que aparece en la ventana de firma debe coincidir con lo que esperas que ocurra después de firmar. Si no entiendes el mensaje o no coincide con tu intención (por ejemplo vender un NFT concreto a un precio concreto), deberías cancelar.",
        "El problema es que muchos flujos de venta/listado de NFT se basan en firmas complejas, y en algunos casos los usuarios firman fuera del marketplace original, en páginas de phishing que imitan el diseño del sitio real."
      ],
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/DarckForest/metamask_sign.jpg",
        alt: "Ventana emergente de MetaMask mostrando una solicitud de firma para listar un NFT en un marketplace.",
        caption:
          "Ejemplo de ventana de firma en MetaMask: el texto parece inocente, pero si no entiendes qué autorizas, puedes estar firmando la venta o cesión de tus NFT a un atacante."
      }
    },
    {
      heading: "Cómo funcionan muchos ataques de firma en NFT",
      text: [
        "Un patrón típico de ataque (con OpenSea u otros mercados como ejemplo) sigue estos pasos:",
        "1) El usuario, en algún momento, firma una orden de listado o de venta legítima en el marketplace.",
        "2) El atacante construye un mensaje de firma similar y lo empaqueta en una página de phishing que imita al marketplace real.",
        "3) El usuario llega a la página falsa (por anuncio, DM, correo, link en redes sociales, etc.) y se le muestra una ventana de firma de su wallet.",
        "4) El texto de la firma es confuso o poco claro; el usuario asume que es “solo un login” o “solo un mensaje de verificación”.",
        "5) Al firmar, en realidad está autorizando una orden que permite al atacante vender sus NFT por un precio ridículamente bajo o transferirlos.",
        "6) El atacante toma esa firma y la envía al contrato del marketplace real, que la considera válida, porque desde su punto de vista el usuario sí firmó correctamente.",
        "Este patrón se conoce como blind signing o firma ciega: el usuario firma sin comprender el alcance real de lo que está aceptando."
      ]
    },
    {
      heading: "Blind signing y la política de mismo origen",
      text: [
        "La razón técnica de fondo es que, hoy en día, la mayoría de wallets no aplican de forma estricta la política de “mismo origen” (same-origin policy) a las firmas.",
        "En un mundo ideal, si una firma está pensada para usarse solo en un dominio (por ejemplo, opensea.io), otra página distinta no debería poder reutilizarla para operar en ese dominio.",
        "Pero en la práctica, muchas firmas son válidas mientras cumplan con el formato del contrato inteligente, independientemente de en qué sitio las hayas firmado.",
        "Resultado: una firma generada en una página de phishing puede tener efecto real sobre tus NFT listados en un marketplace legítimo.",
        "Se han propuesto mejoras a nivel de protocolo (como EIP-712 y otras técnicas de tipado de mensajes) para que las firmas sean más legibles y específicas, pero la responsabilidad final sigue recayendo en dos actores:",
         "🔹 Los wallets, que deben mostrar mensajes claros, legibles y difíciles de falsificar.",
         "🔹 Los usuarios, que deben negarse a firmar aquello que no entienden."
      ]
    },
    {
      heading: "Buenas prácticas al firmar en mercados de NFT",
      text: [
        "Algunas recomendaciones prácticas para reducir riesgos:",
         "🔹 Siempre verifica que la URL del marketplace sea la oficial (dominio, candado HTTPS, ortografía).",
         "🔹 Evita abrir enlaces a supuestos “airdrops de NFT” o “mint gratis” que te llegan por DM o grupos de Telegram/Discord.",
         "🔹 Lee el contenido del mensaje de firma: si tu wallet lo muestra con EIP-712, debe indicar claramente colección, token, precio, moneda, expiración, etc.",
         "🔹 Si ves datos en bruto, hexadecimales incomprensibles o textos genéricos, sé especialmente cautelosa/o.",
         "🔹 No firmes nada cuando estés cansada/o o con prisa. Los mejores ataques se aprovechan de la prisa y la distracción.",
         "🔹 Si algo te huele raro, desconecta la billetera, cierra la página y vuelve a entrar desde la web oficial del proyecto."
      ]
    },
    {
      heading: "Revisar y revocar autorizaciones (approvals)",
      text: [
        "Una vía de ataque frecuente en DeFi y NFT consiste en abusar de autorizaciones (approvals) excesivas: el usuario permite que un contrato mueva TODOS sus tokens o sus NFT, y el atacante explota ese permiso.",
        "Por suerte, existen herramientas para revisar y revocar estas autorizaciones:",
        "Token Approvals (Etherscan):",
        "https://etherscan.io/tokenapprovalchecker",
        "Esta herramienta oficial de Etherscan te permite ver qué contratos tienen permiso para mover tus tokens y cancelarlos si es necesario.",
        "Muchos exploradores de blockchains EVM tienen versiones similares:",
         "🔹 https://bscscan.com/tokenapprovalchecker",
         "🔹 https://hecoinfo.com/tokenapprovalchecker",
         "🔹 https://polygonscan.com/tokenapprovalchecker",
         "🔹 https://snowtrace.io/tokenapprovalchecker",
         "🔹 https://cronoscan.com/tokenapprovalchecker",
        "",
        "Revoke.cash:",
        "https://revoke.cash/",
        "Es uno de los servicios clásicos para revisar y revocar approvals en múltiples cadenas. Tiene buena reputación y se ha vuelto una herramienta casi estándar entre usuarios avanzados.",
        "",
        "Rabby (extensión de wallet):",
        "https://rabby.io/",
        "Rabby incluye dentro de la propia extensión funciones de revisión y cancelación de autorizaciones en muchas redes EVM, de forma bastante cómoda.",
        "Mi recomendación es que te acostumbres a revisar tus approvals periódicamente, en especial después de haber probado muchas DApps nuevas o haber interactuado con minteos masivos de NFT."
      ]
    },
    {
      heading: "Profundizar en seguridad de firmas",
      text: [
        "Si quieres ir mucho más allá y entender los detalles técnicos de la seguridad de firmas (tipos de firma, formatos, vectores de ataque y ejemplos reales), te recomiendo revisar el siguiente repositorio:",
        "https://github.com/evilcos/darkhandbook",
        "Ahí se recopilan materiales y extensiones específicamente orientadas a SIGNATURE SECURITY. No es lectura ligera, pero si logras entender la mayoría de los ejemplos, habrás dado un salto enorme en tu comprensión de la seguridad en Web3.",
        "Aunque al principio parezca abrumador, recuerda esto: cada nueva firma que entiendes bien es una puerta menos para que un atacante se aproveche de ti. En NFT, casi todos los ataques serios pasan por una firma mal entendida."
      ]
    },
    {
      heading: "Resumen: NFT bonitos, pero con casco de seguridad",
      text: [
        "Los NFT pueden ser arte, identidad digital, tickets, membresías o simples coleccionables divertidos. Pero detrás de cada imagen hay contratos, permisos y firmas con consecuencias financieras reales.",
        "Piensa en este capítulo como tu casco de seguridad: no le quita la magia a los NFT, solo te protege de los golpes más tontos.",
        "Si recuerdas solo tres ideas, que sean estas:",
         "🔹 Prefiere metadata bien documentado y en almacenamiento descentralizado.",
         "🔹 Nunca firmes algo que no entiendas (y desconfía de los enlaces sorpresa).",
         "🔹 Revisa y revoca periódicamente las autorizaciones de tus tokens y NFT.",
        "Con esos tres hábitos, ya estás varios pasos por delante de la mayoría de usuarios del ecosistema."
      ]
    }
  
  ]
};

export default CAP;
